export default "__VITE_ASSET__CdJon3cV__"